import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function ReferralErrorPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const reason = searchParams.get("reason");

  const getErrorMessage = () => {

    switch (reason) {
      case 'already_claimed':
        return "REFERRAL DENIED: This account has already claimed a referral bonus.";
      case 'self_referral':
        return "REFERRAL DENIED: You cannot refer your own account.";
      case 'IP already used':
      case 'ip_used':
        return "REFERRAL DENIED: This IP address has already been used for a referral.";
      case 'tax_pool_empty':
        return "REFERRAL DENIED: Global tax pool insufficient for payout.";
      default:
        return "REFERRAL DENIED: Invalid or expired referral code.";
    }
  };

  return (
    <div style={{ 
      display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', 
      backgroundColor: '#050505', color: '#fff', textAlign: 'center', padding: '20px',
      fontFamily: "'JetBrains Mono', monospace"
    }}>
      <div style={{ 
        border: '1px solid #ff4b2b', 
        padding: '40px', 
        borderRadius: '2px', 
        boxShadow: '0 0 20px rgba(255, 75, 43, 0.2)',
        position: 'relative',
        overflow: 'hidden'
      }}>

        <div style={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '2px',
          background: 'linear-gradient(90deg, transparent, #ff4b2b, transparent)',
          animation: 'scan 3s linear infinite'
        }} />

        <h1 style={{ color: '#ff4b2b', textTransform: 'uppercase', letterSpacing: '4px', marginBottom: '10px' }}>
          ERROR
        </h1>
        
        <div style={{ height: '1px', backgroundColor: 'rgba(255, 75, 43, 0.3)', margin: '20px 0' }} />

        <p style={{ margin: '30px 0', fontSize: '14px', lineHeight: '1.6', opacity: 0.9, maxWidth: '400px', color: '#ff8a75' }}>
          {getErrorMessage()}
        </p>

        <button 
          onClick={() => navigate('/')}
          style={{ 
            backgroundColor: '#ff4b2b', 
            border: 'none', 
            color: '#000', 
            padding: '12px 30px', 
            cursor: 'pointer', 
            fontSize: '12px', 
            fontWeight: '900',
            textTransform: 'uppercase',
            letterSpacing: '2px',
            transition: 'all 0.2s ease'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#ff6b52'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#ff4b2b'}
        >
          CONTINUE
        </button>

        <style>{`
          @keyframes scan {
            0% { transform: translateY(-10px); }
            100% { transform: translateY(300px); }
          }
        `}</style>
      </div>
    </div>
  );
}